'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { visuallyHidden } from '@repo/pandacss/patterns';
import { ChevronIcon } from '@repo/ui/icons/ChevronIcon';
import { Typography } from '@repo/ui/Typography';
import { Suspense, useState } from 'react';
import { RecommendationList } from './RecommendationList';
import { MOBILE_RECOMMENDATION_COUNT } from './RecommendationList/constants';
import { Skeleton } from './RecommendationList/Skeleton';
export function MobileRecommendationsPanel() {
  const $ = _c(21);
  const [isExpanded, setIsExpanded] = useState(false);
  const triggerLabel = `${isExpanded ? "Hide" : "Show"} recommendations so far, ${MOBILE_RECOMMENDATION_COUNT} found`;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = css({
      display: {
        base: "block",
        lg: "none"
      },
      position: "relative",
      _before: {
        content: "\"\"",
        position: "absolute",
        top: "[0]",
        left: "[50%]",
        transform: "[translateX(-50%)]",
        borderTop: "[1px solid token(colors.neutral.lighter-2)]",
        borderBottom: "[1px solid token(colors.neutral.lighter-2)]",
        width: "[100vw]",
        height: "[100%]",
        bg: "blues.lightest"
      }
    });
    t1 = <h2 className={visuallyHidden()}>Recommendations so far</h2>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsExpanded(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      border: "none",
      bg: "[transparent]",
      px: "[0]",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "[100%]",
      height: "[48px]",
      position: "relative",
      cursor: "pointer",
      boxSizing: "border-box",
      color: "neutral.darkest"
    });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontWeight: "bold",
      fontFamily: "gotham",
      fontSize: "[14px]",
      color: "neutral.darkest"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isExpanded) {
    t5 = !isExpanded && <span className={css({
      display: "inline-block",
      width: "[24px]",
      height: "[24px]",
      fontSize: "[12px]",
      bg: "blues.main",
      color: "common.white",
      p: "1",
      ml: "1",
      rounded: "full"
    })}>{MOBILE_RECOMMENDATION_COUNT}</span>;
    $[5] = isExpanded;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <Typography as="span" variant="body.small" aria-hidden="true" css={t4}>Recommendations so far{" "}{t5}</Typography>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = isExpanded ? "up" : "down";
  let t8;
  if ($[9] !== t7) {
    t8 = <ChevronIcon position={t7} enableTransition={true} />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isExpanded || $[12] !== t6 || $[13] !== t8 || $[14] !== triggerLabel) {
    t9 = <button type="button" onClick={t2} aria-expanded={isExpanded} aria-controls="mobile-recommendations-cards" aria-label={triggerLabel} className={t3}>{t6}{t8}</button>;
    $[11] = isExpanded;
    $[12] = t6;
    $[13] = t8;
    $[14] = triggerLabel;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isExpanded) {
    t10 = isExpanded && <Suspense fallback={<Skeleton />}><RecommendationList /></Suspense>;
    $[16] = isExpanded;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <section aria-label="Recommendations so far" className={t0}>{t1}{t9}{t10}</section>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp(v) {
  return !v;
}